import styled from '@emotion/styled';

const Section = styled.section`
  text-align: center;
  background-image: url('https://d12xoj7p9moygp.cloudfront.net/images/wordpress/hero-wave.png');
  background-position-x: center;
  background-position-y: -180px;
  background-repeat: no-repeat;
  background-color: #8940fa;
  padding: 80px 24px 0;
  background-size: cover;
  @media (max-width: 768px) {
    padding: 56px 16px 40px 16px;
    background-image: none;
  }
`;

const ContentWrapper = styled.div`
  max-width: 926px;
  width: 100%;
  margin: auto;
`;

const LogoContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  .anchorLogo {
    height: 44px;
  }
  .wpLogo {
    height: 51px;
  }
  @media (max-width: 768px) {
    .wpLogo,
    .anchorLogo {
      height: 32px;
    }
  }
  @media (max-width: 378px) {
    .wpLogo,
    .anchorLogo {
      height: 26px;
    }
  }
`;

const CollabX = styled.span`
  font-style: italic;
  font-weight: normal;
  font-size: 2.8rem;
  line-height: 3.2rem;
  display: inline-block;
  padding: 0 32px 0 24px;
  opacity: 0.5;
  color: #fff;
  position: relative;
  top: 4px;
  @media (max-width: 768px) {
    font-size: 1.8rem;
    line-height: 2rem;
    padding: 0 20px 0 16px;
  }
`;

const SubHeader = styled.h2`
  color: #fff;
  font-size: 1.8rem;
  width: 292px;
  margin: auto;
  line-height: 2.4rem;
  padding: 16px 0 24px 0;
`;

export { Section, ContentWrapper, LogoContainer, CollabX, SubHeader };
